<template>
  <div>
    <v-row v-if="isAdmin" class="mt-4">
      <!-- <v-col :cols="isMobile ? 12 : 1">
        <XLSX
          @get-json="getExcelData"
          v-if="getCurrentUser && getCurrentUser.email == 'adubyte2@yahoo.com'"
        ></XLSX>
      </v-col> -->
      <v-col :cols="isMobile ? 12 : 7">
        <div class="px-6">
          <v-card class="elevation-8" style="border-radius: 16px">
            <v-card-title
              class="text-h4 font-weight-bold primary white--text pa-6"
            >
              <v-icon left large color="white">mdi-email-multiple</v-icon>
              Email Campaign Manager
            </v-card-title>

            <v-tabs
              v-model="activeTab"
              color="primary"
              background-color="grey lighten-4"
              slider-color="primary"
              centered
              grow
            >
              <v-tab class="font-weight-medium">
                <v-icon left>mdi-rocket-launch</v-icon>
                Campaigns
              </v-tab>
              <v-tab class="font-weight-medium">
                <v-icon left>mdi-account-group</v-icon>
                Groups
              </v-tab>
              <v-tab class="font-weight-medium">
                <v-icon left>mdi-account-multiple</v-icon>
                Members
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <!-- CAMPAIGNS TAB -->
              <v-tab-item>
                <v-card-text class="pa-6">
                  <!-- Campaign Creation Section -->
                  <v-card class="mb-6 elevation-4" style="border-radius: 12px">
                    <v-card-text class="pa-6">
                      <v-row>
                        <v-col :cols="isMobile ? 12 : 6">
                          <v-card-title class="primary--text ml-n4 mb-4">
                            <v-icon left color="primary"
                              >mdi-plus-circle</v-icon
                            >
                            Create New Campaign
                          </v-card-title>
                          <v-select
                            v-model="selectedGroup"
                            :items="groups"
                            label="Select Group"
                            outlined
                            dense
                            prepend-inner-icon="mdi-account-group"
                            @change="getSelectedGroupMembers"
                            :loading="loadingMembers"
                          ></v-select>
                        </v-col>
                        <v-col :cols="isMobile ? 12 : 6">
                          <div v-if="members.length" class="mt-n5">
                            <v-card-title class="primary--text ml-n4">
                              <v-icon left color="primary"
                                >mdi-account-multiple</v-icon
                              >
                              <v-switch
                                v-model="switchSelectAllMembers"
                                :label="`Select All ${members.length} Members`"
                                @change="getSelectAllMembersSwitch"
                              ></v-switch>
                              <v-text-field
                                class="ml-2"
                                label="Select By Name"
                                v-model="groupMembersFilter"
                                @change="filterGroupMembersByItem"
                              ></v-text-field>
                            </v-card-title>
                            <v-autocomplete
                              v-model="selectedMembers"
                              :items="members"
                              item-text="name"
                              item-value="id"
                              label="Select Members"
                              multiple
                              chips
                              outlined
                              dense
                              prepend-inner-icon="mdi-account-multiple"
                            >
                              <template v-slot:selection="{ item, index }">
                                <v-chip
                                  v-if="index < 3"
                                  color="primary"
                                  text-color="white"
                                  small
                                  close
                                  @click:close="removeSelectedMember(item.id)"
                                >
                                  {{ item.name }}
                                </v-chip>
                                <span
                                  v-if="index === 3"
                                  class="grey--text text-caption"
                                >
                                  (+{{ selectedMembers.length - 3 }} others)
                                </span>
                              </template>
                            </v-autocomplete>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="campaign.title"
                            label="Campaign Title"
                            outlined
                            dense
                            prepend-inner-icon="mdi-format-title"
                            :rules="[(v) => !!v || 'Title is required']"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <DateTimePicker
                            bgColor="white"
                            @date-time-picked="getSelectedDateTime"
                            :defaultDateTime="campaign.send_time"
                          ></DateTimePicker>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-select
                            v-model="campaign.frequency"
                            :items="frequencyOptions"
                            label="Frequency"
                            outlined
                            dense
                            prepend-inner-icon="mdi-repeat"
                          ></v-select>
                        </v-col>
                      </v-row>

                      <!-- AI GENERATOR -->
                      <v-btn
                        x-large
                        color="warning"
                        dark
                        class="mb-4"
                        @click="openAIEmailDialog"
                        >Generate Email With Ai<v-icon right
                          >mdi-creation</v-icon
                        ></v-btn
                      >
                      <!-- TINYMCE EDITOR -->
                      <div class="mb-4">
                        <label class="v-label theme--light"
                          >Email Content</label
                        >
                        <div
                          ref="editorContainer"
                          style="min-height: 500px; border: 1px solid #ddd"
                        >
                          <div
                            v-if="!editor && !loading"
                            class="editor-placeholder d-flex align-center justify-center"
                          >
                            <v-progress-circular
                              v-if="loadingEditor"
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                            <span v-else
                              >Editor will be initialized once API key is
                              provided</span
                            >
                          </div>
                        </div>
                      </div>
                      <!-- <v-textarea
                        v-if="!AIEmailContext"
                        v-model="campaign.content"
                        label="Email Content (HTML allowed)"
                        outlined
                        rows="6"
                        prepend-inner-icon="mdi-file-document-edit"
                        :rules="[(v) => !!v || 'Content is required']"
                      ></v-textarea> -->
                      <!-- Rendered HTML Preview -->
                      <!-- <v-card class="mt-4" outlined v-else>
                        <v-card-title>Preview</v-card-title>
                        <v-card-text>
                          <div
                            style="
                              background-color: rgb(0, 0, 0);
                              color: rgb(255, 255, 255);
                              min-height: 150px;
                              padding: 10px;
                              border-radius: 16px;
                            "
                            v-html="campaign.content"
                            contenteditable="true"
                            @input="updateContent"
                          ></div>
                        </v-card-text>
                      </v-card> -->

                      <!-- EDITOR JS CONTAINER -->
                      <!-- <div class="editor-container mb-4" id="editor-wrapper">
                        <div class="editor-header">
                          <svg
                            class="editor-header-icon"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
                            />
                          </svg>
                          <h3>Content Editor</h3>
                          <div class="editor-status">
                            <div class="status-dot"></div>
                            Ready
                          </div>
                        </div>

                        <div id="editorjs"></div>

                        <div class="editor-footer">
                          <div class="word-count">0 words</div>
                          <div class="last-saved">Auto-saved</div>
                        </div>
                      </div> -->

                      <v-btn
                        color="primary"
                        large
                        depressed
                        :loading="scheduling"
                        @click="scheduleCampaign"
                        :disabled="!canSchedule"
                        class="mr-3"
                      >
                        <v-icon left>mdi-rocket-launch</v-icon>
                        Schedule Campaign
                      </v-btn>

                      <v-btn
                        v-if="editingCampaign"
                        outlined
                        large
                        @click="cancelEdit"
                      >
                        Cancel Edit
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-tab-item>

              <!-- GROUPS TAB -->
              <v-tab-item>
                <v-card-text class="pa-6">
                  <v-card class="elevation-4" style="border-radius: 12px">
                    <v-card-title class="primary--text">
                      <v-icon left color="primary">mdi-account-group</v-icon>
                      Group Management
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        depressed
                        @click="openGroupDialog()"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        Add Group
                      </v-btn>
                    </v-card-title>

                    <v-data-table
                      :headers="groupHeaders"
                      :items="groups"
                      item-key="id"
                      :loading="loadingGroups"
                      class="elevation-0"
                    >
                      <template v-slot:item.member_count="{ item }">
                        <v-chip color="primary" text-color="white" small>
                          {{ item.member_count || 0 }} members
                        </v-chip>
                      </template>

                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          small
                          icon
                          color="primary"
                          @click="openGroupDialog(item)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>

                        <v-btn
                          small
                          icon
                          color="error"
                          @click="deleteGroup(item)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card-text>
              </v-tab-item>

              <!-- MEMBERS TAB -->
              <v-tab-item>
                <v-card-text class="pa-6">
                  <v-card class="elevation-4" style="border-radius: 12px">
                    <v-card-title class="primary--text">
                      <v-icon left color="primary">mdi-account-multiple</v-icon>
                      Member Management
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="memberSearch"
                        append-icon="mdi-magnify"
                        label="Search members..."
                        single-line
                        hide-details
                        outlined
                        dense
                        style="max-width: 300px"
                        class="mr-3"
                      ></v-text-field>
                      <v-btn
                        color="primary"
                        depressed
                        @click="openMemberDialog()"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        Add Member
                      </v-btn>
                    </v-card-title>

                    <v-data-table
                      :headers="memberHeaders"
                      :items="allMembers"
                      :search="memberSearch"
                      item-key="id"
                      :loading="loadingAllMembers"
                      class="elevation-0"
                    >
                      <template v-slot:item.groups="{ item }">
                        <v-chip
                          v-for="group in item.groups"
                          :key="group.id"
                          color="secondary"
                          text-color="white"
                          small
                          class="mr-1"
                        >
                          {{ group.name }}
                        </v-chip>
                      </template>

                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          small
                          icon
                          color="primary"
                          @click="openMemberDialog(item)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>

                        <v-btn
                          small
                          icon
                          color="error"
                          @click="deleteMember(item)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card-text>
              </v-tab-item>
            </v-tabs-items>
          </v-card>

          <!-- Group Dialog -->
          <v-dialog v-model="groupDialog" max-width="600px" persistent>
            <v-card style="border-radius: 16px">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-account-group</v-icon>
                {{ editingGroup ? "Edit Group" : "Add New Group" }}
              </v-card-title>

              <v-card-text class="pa-6">
                <v-text-field
                  v-model="groupForm.name"
                  label="Group Name"
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-group"
                  :rules="[(v) => !!v || 'Name is required']"
                ></v-text-field>

                <v-textarea
                  v-model="groupForm.description"
                  label="Description (Optional)"
                  outlined
                  rows="3"
                  prepend-inner-icon="mdi-text"
                ></v-textarea>
              </v-card-text>

              <v-card-actions class="pa-6">
                <v-spacer></v-spacer>
                <v-btn outlined @click="closeGroupDialog"> Cancel </v-btn>
                <v-btn
                  color="primary"
                  depressed
                  :loading="savingGroup"
                  @click="saveGroup"
                  :disabled="!groupForm.name"
                >
                  {{ editingGroup ? "Update" : "Create" }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- AI Email Dialog -->
          <v-dialog v-model="AIEmailDialog" max-width="700px" persistent>
            <v-card>
              <v-card-title style="background-color: deepskyblue; color: azure"
                >Tell AI About Your Email Content</v-card-title
              >
              <v-textarea
                class="mx-4"
                outline
                :rows="4"
                label="Tell AI About The Specifics Of Your Email"
                v-model="AIEmailContext"
              ></v-textarea>
              <v-card-actions>
                <v-btn color="error" @click="closeAIEmailDialog()"
                  >Cancel</v-btn
                >
                <v-btn color="warning" @click="generateEmailBodyWithAI()"
                  >Generate Email Now <v-icon>mdi-creation</v-icon></v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Member Dialog -->
          <v-dialog v-model="memberDialog" max-width="700px" persistent>
            <v-card style="border-radius: 16px">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-account</v-icon>
                {{ editingMember ? "Edit Member" : "Add New Member" }}
              </v-card-title>

              <v-card-text class="pa-6">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="memberForm.name"
                      label="Full Name"
                      outlined
                      dense
                      prepend-inner-icon="mdi-account"
                      :rules="[(v) => !!v || 'Name is required']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="memberForm.email"
                      label="Email Address"
                      type="email"
                      outlined
                      dense
                      prepend-inner-icon="mdi-email"
                      :rules="emailRules"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="memberForm.phone_number"
                      label="Phone Number"
                      outlined
                      dense
                      prepend-inner-icon="mdi-phone"
                      :rules="[(v) => !!v || 'Phone number is required']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="memberForm.emis"
                      label="EMIS"
                      outlined
                      dense
                      prepend-inner-icon="mdi-identifier"
                      :rules="[(v) => !!v || 'EMIS is required']"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-text-field
                  v-model="memberForm.institution"
                  label="Institution"
                  outlined
                  dense
                  prepend-inner-icon="mdi-school"
                ></v-text-field>

                <v-select
                  v-model="memberForm.group_ids"
                  :items="groups"
                  item-text="text"
                  item-value="value.id"
                  label="Assign to Groups"
                  multiple
                  chips
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-group"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip
                      v-if="index < 2"
                      color="secondary"
                      text-color="white"
                      small
                      close
                      @click:close="removeMemberGroup(item.value.id)"
                    >
                      {{ item.text }}
                    </v-chip>
                    <span v-if="index === 2" class="grey--text text-caption">
                      (+{{ memberForm.group_ids.length - 2 }} others)
                    </span>
                  </template>
                </v-select>
              </v-card-text>

              <v-card-actions class="pa-6">
                <v-spacer></v-spacer>
                <v-btn outlined @click="closeMemberDialog"> Cancel </v-btn>
                <v-btn
                  color="primary"
                  depressed
                  :loading="savingMember"
                  @click="saveMember"
                  :disabled="!isValidMember"
                >
                  {{ editingMember ? "Update" : "Create" }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Resend Campaign Dialog -->
          <v-dialog v-model="resendDialog" max-width="800px" persistent>
            <v-card style="border-radius: 16px">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-send</v-icon>
                Resend Campaign: {{ resendingCampaign.title }}
              </v-card-title>

              <v-card-text class="pa-6">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="resendSelectedGroup"
                      :items="groups"
                      label="Select Group"
                      outlined
                      dense
                      prepend-inner-icon="mdi-account-group"
                      @change="getResendGroupMembers"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-if="resendMembers.length"
                      v-model="resendSelectedMembers"
                      :items="resendMembers"
                      item-text="name"
                      item-value="id"
                      label="Select Members"
                      multiple
                      chips
                      outlined
                      dense
                      prepend-inner-icon="mdi-account-multiple"
                    ></v-autocomplete>
                  </v-col>
                </v-row>

                <v-text-field
                  v-model="resendCampaignData.title"
                  label="Campaign Title"
                  outlined
                  dense
                  prepend-inner-icon="mdi-format-title"
                ></v-text-field>

                <v-textarea
                  v-model="resendCampaignData.content"
                  label="Email Content"
                  outlined
                  rows="6"
                  prepend-inner-icon="mdi-file-document-edit"
                  readonly
                ></v-textarea>
              </v-card-text>

              <v-card-actions class="pa-6">
                <v-spacer></v-spacer>
                <v-btn outlined @click="closeResendDialog"> Cancel </v-btn>
                <v-btn
                  color="primary"
                  depressed
                  :loading="resending"
                  @click="confirmResend"
                  :disabled="!resendSelectedMembers.length"
                >
                  <v-icon left>mdi-send</v-icon>
                  Resend Campaign
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Snackbar for notifications -->
          <v-snackbar
            v-model="snackbar.show"
            :color="snackbar.color"
            :timeout="4000"
            top
            right
          >
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
              <v-btn text v-bind="attrs" @click="snackbar.show = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </div></v-col
      >
      <v-col :cols="isMobile ? 12 : 4" class="mx-6">
        <v-card-title
          class="text-h4 font-weight-bold primary white--text pa-6"
          style="border-radius: 16px"
        >
          <v-icon left large color="white">mdi-email-multiple</v-icon>
          Campaign History
        </v-card-title>
        <v-card class="elevation-4 mt-n2">
          <v-card-title class="primary--text">
            <v-icon left color="primary">mdi-email-multiple</v-icon>

            <v-spacer></v-spacer>
            <v-text-field
              v-model="campaignSearch"
              append-icon="mdi-magnify"
              label="Search campaigns..."
              single-line
              hide-details
              outlined
              dense
              style="max-width: 300px"
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="campaignHeaders"
            :items="campaigns"
            :search="campaignSearch"
            item-key="id"
            :loading="loadingCampaigns"
            class="elevation-0"
          >
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="getStatusColor(item.status)"
                text-color="white"
                small
              >
                {{ item.status }}
              </v-chip>
            </template>

            <template v-slot:item.analytics="{ item }">
              <div class="text-center">
                <v-chip color="success" text-color="white" small class="mr-1">
                  {{ item.opens || 0 }} opens
                </v-chip>
                <v-chip color="info" text-color="white" small>
                  {{ item.clicks || 0 }} clicks
                </v-chip>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                icon
                color="primary"
                @click="editCampaign(item)"
                :disabled="item.status === 'sent'"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-btn small icon color="success" @click="resendCampaign(item)">
                <v-icon>mdi-send</v-icon>
              </v-btn>

              <v-btn small icon color="error" @click="deleteCampaign(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card></v-col
      >
    </v-row>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import emailJs from "@/plugins/emails.js";
import XLSX from "@/components/myLibrary/XLSX.vue";
import DateTimePicker from "@/components/myLibrary/DateTimePicker.vue";

//Editor js libraries
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Table from "@editorjs/table";
import CodeTool from "@editorjs/code";
import Paragraph from "@editorjs/paragraph";
import Parser from "editorjs-parser";

export default {
  components: { XLSX, DateTimePicker },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    canSchedule() {
      return this.campaign.title && this.selectedMembers.length > 0;
    },

    isValidMember() {
      return (
        this.memberForm.name &&
        this.memberForm.phone_number &&
        this.memberForm.emis &&
        (this.memberForm.email ? /.+@.+\..+/.test(this.memberForm.email) : true)
      );
    },
  },
  data() {
    return {
      //TinyMCE
      loading: false,
      loadingEditor: false,
      apiKeyDialog: false,
      tinyMceApiKey: "hy8s6xao0td22aguol8z5xsjooqwghvqynbyb7p8uz73otc4",
      saveApiKey: true,
      tinymceLoaded: false,
      editor: null,

      AIEmailDialog: false,
      AIEmailContext: "",
      groupMembersFilter: "",
      switchSelectAllMembers: false,
      activeTab: 0,
      table: null,
      // Campaign data
      groups: [],
      members: [],
      selectedGroup: null,
      selectedMembers: [],
      campaign: {
        title: "",
        content: "",
        send_time:
          new Date().toJSON().substring(0, 10) +
          " " +
          new Date().toLocaleTimeString(),
        frequency: "Now",
      },
      campaigns: [],
      editingCampaign: false,

      // UI states
      dateMenu: false,
      scheduling: false,
      loadingMembers: false,
      loadingCampaigns: false,
      campaignSearch: "",

      // Group management
      groupDialog: false,
      groupForm: {
        name: "",
        description: "",
      },
      editingGroup: false,
      savingGroup: false,
      loadingGroups: false,

      // Member management
      memberDialog: false,
      memberForm: {
        name: "",
        email: "",
        phone_number: "",
        institution: "",
        emis: "",
        group_ids: [],
      },
      editingMember: false,
      savingMember: false,
      allMembers: [],
      loadingAllMembers: false,
      memberSearch: "",

      // Resend functionality
      resendDialog: false,
      resendingCampaign: {},
      resendCampaignData: {},
      resendSelectedGroup: null,
      resendMembers: [],
      resendSelectedMembers: [],
      resending: false,

      // Notification
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },

      // Form validation
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],

      // Table headers
      campaignHeaders: [
        { text: "Title", value: "title", sortable: true },
        { text: "Send Date", value: "send_time", sortable: true },
        { text: "Frequency", value: "frequency" },
        { text: "Status", value: "status" },
        { text: "Analytics", value: "analytics", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],

      groupHeaders: [
        { text: "Name", value: "name", sortable: true },
        { text: "Description", value: "description" },
        { text: "Members", value: "member_count" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      memberHeaders: [
        { text: "Name", value: "name", sortable: true },
        { text: "Email", value: "email", sortable: true },
        { text: "Phone", value: "phone_number" },
        { text: "Institution", value: "institution" },
        { text: "EMIS", value: "emis" },
        { text: "Groups", value: "groups", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],

      frequencyOptions: [
        "Now",
        "Specified Day & Time",
        "Daily",
        "Weekly",
        "Monthly",
      ],
      chatGPTKey:
        "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",
    };
  },

  mounted() {
    //this.renderEditorJs();
    this.fetchGroups();
    this.loadTinyMCE();
    //this.fetchCampaigns();
    //this.fetchAllMembers();
  },
  beforeDestroy() {
    if (window.tinymce && this.editor) {
      window.tinymce.remove(this.editor);
    }
  },

  methods: {
    openAIEmailDialog() {
      this.AIEmailDialog = true;
    },
    closeAIEmailDialog() {
      this.AIEmailDialog = false;
    },
    updateContent(event) {
      this.campaign.content = event.target.innerHTML;
    },
    async generateEmailBodyWithAI() {
      if (!this.campaign.title || !this.AIEmailContext) {
        this.$toast.info("Provide Title And Context For AI Email Generation!", {
          duration: 5000,
        });
        return false;
      }

      this.$store.commit("setLoader", true);
      const prompt = `You are a professional administrative secretary and an expert email marketer.
      Write a professional email campaign for the subject "${this.campaign.title}",
      based on this text content : ${this.AIEmailContext}.
      the email campaign must meet the following requirements.
      1. the email must have a subject that compels or motivate recipients to open it or want to read it.
      2. the email must create curiosity.
      3. the email must drive clicks and conversions
      4. the email must be well formatted using headers, paragraphs, lists, bullets, emojis etc.
      5. if an website or web link is provided, then the email must have a call to action to visit the link or the site by clicking on the button provided in the email.
      6. Use different colors and proper styling to make the email visually appealing to the recipient.

      Check and correct all spelling mistakes, and ensure the tone is formal and professional.
      Provide the email content formatted strictly as An HTML-formatted email body with strong persuasive tone, with social proof, urgency, and benefits including types like "paragraph", "header", "list", or "code" blocks as needed.
      Do NOT include any explanations, comments, or code blocks outside the JSON. Output ONLY An HTML-formatted email body, so it can be directly used as input into an html editor;
      `;
      try {
        let response = await this.generateWithChatGPT(prompt);

        // Sanitize if necessary: remove code block syntax, etc.
        response = response
          .trim()
          .replace(/^```(json)?/, "")
          .replace(/```$/, "");
        if (this.editor) {
          this.editor.setContent(response);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.closeAIEmailDialog();
        this.$store.commit("setLoader", false);
      }
    },
    async generateWithChatGPT(prompt) {
      const response = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.chatGPTKey}`,
          },
          body: JSON.stringify({
            model: "gpt-4",
            messages: [{ role: "user", content: prompt }],
            temperature: 0.4,
          }),
        }
      );

      const json = await response.json();
      return (
        (json.choices &&
          json.choices[0] &&
          json.choices[0].message &&
          json.choices[0].message.content) ||
        "Failed to generate document"
      );

      //return json.choices[0]?.message?.content || "Failed to generate document";
    },
    filterGroupMembersByItem() {
      if (this.groupMembersFilter) {
        this.selectedMembers = [];
        this.members.forEach((member) => {
          if (
            member.name
              .toLowerCase()
              .includes(this.groupMembersFilter.toLowerCase())
          ) {
            this.selectedMembers.push(member.id);
          }
        });
      } else {
        this.selectedMembers = [];
      }
    },
    getExcelData(jsonData) {
      if (jsonData.length > 0) {
        const data = [];

        for (let index = 1; index < jsonData.length; index++) {
          const row = jsonData[index];
          data.push({
            institution: row[4],
            name:
              "Principal " +
              row[0] +
              " " +
              row[2] +
              " " +
              row[3] +
              " " +
              row[7] +
              " LAT:" +
              row[8] +
              " LONG:" +
              row[9],
            group_id: 1,
            email: row[10],
            phone_number: "000 000 0000",
            emis: this.getCurrentUser.emis,
          });
        }

        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/upload-schools-data-from-doe-excel",
            { dataArrayOfObjs: data },
            this.getAccessToken
          )
          .then((response) => {
            console.log(response);
            this.$store.commit("setLoader", false);
          });
      }
    },
    getSelectAllMembersSwitch() {
      if (this.switchSelectAllMembers) {
        this.selectedMembers = [];
        this.members.forEach((member) => {
          this.selectedMembers.push(member.id);
        });
      } else {
        this.selectedMembers = [];
      }
    },
    // Campaign methods
    async fetchGroups() {
      this.loadingGroups = true;
      try {
        const groups = await emailJs.getAllEmailsGroups();
        this.groups = groups.map((group) => ({
          text: `${group.name}`,
          value: group,
          ...group,
        }));
      } catch (error) {
        this.showSnackbar("Error fetching groups", "error");
      } finally {
        this.loadingGroups = false;
      }
    },

    async getSelectedGroupMembers() {
      if (!this.selectedGroup) return;
      if (
        this.selectedGroup.name == "Clients" ||
        this.selectedGroup.name == "Users" ||
        this.selectedGroup.name == "Staff"
      ) {
        this.table = this.selectedGroup.name.toLowerCase();
      } else {
        this.table = "group_members";
      }
      this.loadingMembers = true;
      try {
        this.members = await emailJs.getSelectedEmailGroupMembers(
          this.selectedGroup.name,
          this.selectedGroup.id
        );
      } catch (error) {
        this.showSnackbar("Error fetching group members", "error");
      } finally {
        this.loadingMembers = false;
      }
    },

    async fetchCampaigns() {
      this.loadingCampaigns = true;
      try {
        const response = await fetch("/api/email-campaigns");
        this.campaigns = await response.json();
      } catch (error) {
        this.showSnackbar("Error fetching campaigns", "error");
      } finally {
        this.loadingCampaigns = false;
      }
    },

    async scheduleCampaign() {
      this.campaign.content = this.getEditorContent();

      if (!this.canSchedule || !this.campaign.content) {
        this.$toast.info("All Fields Are Required!", { duration: 5000 });
        return false;
      }

      this.scheduling = true;
      try {
        const payload = {
          ...this.campaign,
          member_ids: this.selectedMembers,
          table: this.table,
        };

        const url = this.editingCampaign
          ? "/auth/edit-sent-email"
          : "/auth/send-bulk-emails";

        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(url, payload, this.getAccessToken)
          .then((response) => {
            this.$store.commit("setLoader", false);
            this.$toast.success("Campaign scheduled successfully!", {
              duration: 5000,
            });
            if (response) {
              this.showSnackbar(
                this.editingCampaign
                  ? "Campaign updated successfully"
                  : "Campaign scheduled successfully",
                "success"
              );

              //this.resetCampaignForm();
              this.fetchCampaigns();
            } else {
              throw new Error("Failed to save campaign");
            }
          });
      } catch (error) {
        this.showSnackbar("Error saving campaign", "error");
      } finally {
        this.scheduling = false;
      }
    },
    getSelectedDateTime(dateTime) {
      this.campaign.send_time = dateTime;
    },

    editCampaign(item) {
      this.campaign = { ...item };
      this.selectedMembers = item.member_ids || [];
      this.editingCampaign = true;
      this.activeTab = 0; // Switch to campaigns tab

      // Scroll to form
      this.$nextTick(() => {
        this.$el
          .querySelector(".v-card")
          .scrollIntoView({ behavior: "smooth" });
      });
    },

    cancelEdit() {
      this.resetCampaignForm();
    },

    renderEditorJs() {
      this.editor = new EditorJS({
        holder: "editorjs",
        placeholder: "",
        tools: {
          header: Header,
          list: List,
          table: Table,
          code: CodeTool,
          paragraph: {
            class: Paragraph,
            inlineToolbar: true,
          },
        },
      });

      //Only Responsible for styling of editor
      const editorContainer = document.getElementById("editor-wrapper");
      const editorElement = document.getElementById("editorjs");

      editorElement.addEventListener("focus", () => {
        editorContainer.classList.add("focused");
      });

      editorElement.addEventListener("blur", () => {
        editorContainer.classList.remove("focused");
      });

      // Simple word counter (you can enhance this based on Editor.js content)
      const wordCountElement = document.querySelector(".word-count");
      const updateWordCount = () => {
        const text = editorElement.textContent || "";
        const words = text.trim() ? text.trim().split(/\s+/).length : 0;
        wordCountElement.textContent = `${words} word${words !== 1 ? "s" : ""}`;
      };

      // Update word count on input
      editorElement.addEventListener("input", updateWordCount);

      // Initialize
      updateWordCount();
    },

    resetCampaignForm() {
      this.campaign = {
        title: "",
        content: "",
        send_time: "",
        frequency: "once",
      };
      this.selectedMembers = [];
      this.selectedGroup = null;
      this.members = [];
      this.editingCampaign = false;
    },

    async deleteCampaign(item) {
      if (confirm(`Are you sure you want to delete "${item.title}"?`)) {
        try {
          const response = await fetch(`/api/email-campaigns/${item.id}`, {
            method: "DELETE",
          });

          if (response.ok) {
            this.showSnackbar("Campaign deleted successfully", "success");
            this.fetchCampaigns();
          } else {
            throw new Error("Failed to delete campaign");
          }
        } catch (error) {
          this.showSnackbar("Error deleting campaign", "error");
        }
      }
    },

    // Resend campaign methods
    resendCampaign(item) {
      this.resendingCampaign = { ...item };
      this.resendCampaignData = {
        title: `${item.title} (Resend)`,
        content: item.content,
        send_time: new Date().toISOString().substr(0, 10),
        frequency: "once",
      };
      this.resendSelectedGroup = null;
      this.resendMembers = [];
      this.resendSelectedMembers = [];
      this.resendDialog = true;
    },

    async getResendGroupMembers() {
      if (!this.resendSelectedGroup) return;

      try {
        this.resendMembers = await emailJs.getSelectedEmailGroupMembers(
          this.resendSelectedGroup.name,
          this.resendSelectedGroup.id
        );
      } catch (error) {
        this.showSnackbar("Error fetching group members", "error");
      }
    },

    async confirmResend() {
      if (!this.resendSelectedMembers.length) return;

      this.resending = true;
      try {
        const payload = {
          ...this.resendCampaignData,
          member_ids: this.resendSelectedMembers,
        };

        const response = await fetch("/api/email-campaigns", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          this.showSnackbar("Campaign resent successfully", "success");
          this.closeResendDialog();
          this.fetchCampaigns();
        } else {
          throw new Error("Failed to resend campaign");
        }
      } catch (error) {
        this.showSnackbar("Error resending campaign", "error");
      } finally {
        this.resending = false;
      }
    },

    closeResendDialog() {
      this.resendDialog = false;
      this.resendingCampaign = {};
      this.resendCampaignData = {};
      this.resendSelectedGroup = null;
      this.resendMembers = [];
      this.resendSelectedMembers = [];
    },

    // Group management methods
    openGroupDialog(group = null) {
      if (group) {
        this.groupForm = { ...group };
        this.editingGroup = true;
      } else {
        this.groupForm = { name: "", description: "" };
        this.editingGroup = false;
      }
      this.groupDialog = true;
    },

    closeGroupDialog() {
      this.groupDialog = false;
      this.groupForm = { name: "", description: "" };
      this.editingGroup = false;
    },

    async saveGroup() {
      if (!this.groupForm.name) return;

      this.savingGroup = true;
      try {
        const url = this.editingGroup
          ? `/api/groups/${this.groupForm.id}`
          : "/api/groups";

        const method = this.editingGroup ? "PUT" : "POST";

        const response = await fetch(url, {
          method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.groupForm),
        });

        if (response.ok) {
          this.showSnackbar(
            this.editingGroup
              ? "Group updated successfully"
              : "Group created successfully",
            "success"
          );

          this.closeGroupDialog();
          this.fetchGroups();
        } else {
          throw new Error("Failed to save group");
        }
      } catch (error) {
        this.showSnackbar("Error saving group", "error");
      } finally {
        this.savingGroup = false;
      }
    },

    async deleteGroup(group) {
      if (
        confirm(
          `Are you sure you want to delete "${group.name}"? This will remove all members from this group.`
        )
      ) {
        try {
          const response = await fetch(`/api/groups/${group.id}`, {
            method: "DELETE",
          });

          if (response.ok) {
            this.showSnackbar("Group deleted successfully", "success");
            this.fetchGroups();
            this.fetchAllMembers();
          } else {
            throw new Error("Failed to delete group");
          }
        } catch (error) {
          this.showSnackbar("Error deleting group", "error");
        }
      }
    },

    // Member management methods
    async fetchAllMembers() {
      this.loadingAllMembers = true;
      try {
        const response = await fetch("/api/members");
        const members = await response.json();

        // Fetch group details for each member
        this.allMembers = await Promise.all(
          members.map(async (member) => {
            if (member.group_id) {
              const groupIds = Array.isArray(member.group_id)
                ? member.group_id
                : member.group_id.split(",");

              const groups = await Promise.all(
                groupIds.map(async (groupId) => {
                  try {
                    const groupResponse = await fetch(`/api/groups/${groupId}`);
                    return await groupResponse.json();
                  } catch {
                    return { id: groupId, name: "Unknown Group" };
                  }
                })
              );

              return { ...member, groups };
            }
            return { ...member, groups: [] };
          })
        );
      } catch (error) {
        this.showSnackbar("Error fetching members", "error");
      } finally {
        this.loadingAllMembers = false;
      }
    },

    openMemberDialog(member = null) {
      if (member) {
        this.memberForm = {
          ...member,
          group_ids: member.group_id
            ? Array.isArray(member.group_id)
              ? member.group_id
              : member.group_id.split(",")
            : [],
        };
        this.editingMember = true;
      } else {
        this.memberForm = {
          name: "",
          email: "",
          phone_number: "",
          institution: "",
          emis: "",
          group_ids: [],
        };
        this.editingMember = false;
      }
      this.memberDialog = true;
    },

    closeMemberDialog() {
      this.memberDialog = false;
      this.memberForm = {
        name: "",
        email: "",
        phone_number: "",
        institution: "",
        emis: "",
        group_ids: [],
      };
      this.editingMember = false;
    },

    async saveMember() {
      if (!this.isValidMember) return;

      this.savingMember = true;
      try {
        const memberData = {
          ...this.memberForm,
          group_id: this.memberForm.group_ids.length
            ? this.memberForm.group_ids.join(",")
            : null,
        };

        delete memberData.group_ids;

        const url = this.editingMember
          ? `/api/members/${this.memberForm.id}`
          : "/api/members";

        const method = this.editingMember ? "PUT" : "POST";

        const response = await fetch(url, {
          method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(memberData),
        });

        if (response.ok) {
          this.showSnackbar(
            this.editingMember
              ? "Member updated successfully"
              : "Member created successfully",
            "success"
          );

          this.closeMemberDialog();
          this.fetchAllMembers();
          this.fetchGroups(); // Update member counts in groups
        } else {
          throw new Error("Failed to save member");
        }
      } catch (error) {
        this.showSnackbar("Error saving member", "error");
      } finally {
        this.savingMember = false;
      }
    },

    async deleteMember(member) {
      if (confirm(`Are you sure you want to delete "${member.name}"?`)) {
        try {
          const response = await fetch(`/api/members/${member.id}`, {
            method: "DELETE",
          });

          if (response.ok) {
            this.showSnackbar("Member deleted successfully", "success");
            this.fetchAllMembers();
            this.fetchGroups(); // Update member counts
          } else {
            throw new Error("Failed to delete member");
          }
        } catch (error) {
          this.showSnackbar("Error deleting member", "error");
        }
      }
    },

    // Utility methods
    removeSelectedMember(memberId) {
      this.selectedMembers = this.selectedMembers.filter(
        (id) => id !== memberId
      );
    },

    removeMemberGroup(groupId) {
      this.memberForm.group_ids = this.memberForm.group_ids.filter(
        (id) => id !== groupId
      );
    },

    getStatusColor(status) {
      const colors = {
        scheduled: "primary",
        sending: "warning",
        sent: "success",
        failed: "error",
        draft: "grey",
      };
      return colors[status] || "grey";
    },

    showSnackbar(message, color = "success") {
      this.snackbar = {
        show: true,
        message,
        color,
      };
    },
    saveAndInitTinyMCE() {
      if (this.tinyMceApiKey) {
        if (this.saveApiKey) {
          localStorage.setItem(API_KEY_STORAGE_KEY, this.tinyMceApiKey);
        }
        this.apiKeyDialog = false;
        this.loadTinyMCE();
      } else {
        this.showSnackbar("Please enter a valid API key", "error");
      }
    },

    loadTinyMCE() {
      this.loadingEditor = true;

      // Remove any existing script to avoid conflicts
      const existingScript = document.getElementById("tinymce-script");
      if (existingScript) {
        existingScript.remove();
      }

      // Create new script element
      const script = document.createElement("script");
      script.id = "tinymce-script";
      script.src = `https://cdn.tiny.cloud/1/${this.tinyMceApiKey}/tinymce/5/tinymce.min.js`;
      script.referrerPolicy = "origin";

      script.onload = () => {
        this.tinymceLoaded = true;
        this.initTinyMCE();
      };

      script.onerror = () => {
        this.showSnackbar(
          "Failed to load TinyMCE editor. Please check your API key and internet connection.",
          "error"
        );
        this.loadingEditor = false;
        this.apiKeyDialog = true;
      };

      document.head.appendChild(script);
    },

    initTinyMCE() {
      if (!this.tinymceLoaded) {
        this.showSnackbar("TinyMCE editor is not loaded yet.", "error");
        return;
      }

      // If editor exists, remove it first
      if (window.tinymce && this.editor) {
        window.tinymce.remove(this.editor);
      }

      window.tinymce.init({
        target: this.$refs.editorContainer,
        height: 700,
        menubar: true,
        branding: false,
        convert_urls: false,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste help wordcount",
          "hr pagebreak nonbreaking template textcolor",
          "textpattern visualchars emoticons codesample",
          "directionality importcss tabfocus autosave",
        ],
        toolbar: [
          "undo redo | formatselect | bold italic underline strikethrough | forecolor backcolor",
          "alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",
          "removeformat | link image media table | charmap emoticons hr",
          "fullscreen preview print | help",
        ],
        toolbar_mode: "sliding",
        contextmenu: "link image table",
        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        templates: [
          {
            title: "Marketing Newsletter",
            description: "Basic newsletter template",
            content:
              "<h2>Newsletter Title</h2><p>Welcome to our newsletter!</p>",
          },
          {
            title: "Product Announcement",
            description: "Product launch template",
            content:
              "<h2>New Product Launch</h2><p>We're excited to announce our new product!</p>",
          },
          {
            title: "Promotion Email",
            description: "Sales promotion template",
            content:
              "<h2>Special Offer</h2><p>Limited time offer: Get 20% off!</p>",
          },
        ],
        // Add tooltips for buttons
        setup: (editor) => {
          this.editor = editor;

          // Add tooltips to buttons
          editor.on("init", () => {
            // Add tooltip attributes to toolbar buttons
            const buttons = document.querySelectorAll(".tox-tbtn");
            buttons.forEach((button) => {
              const ariaLabel = button.getAttribute("aria-label");
              if (ariaLabel) {
                button.setAttribute("title", ariaLabel);
              }
            });
          });
        },
        init_instance_callback: (editor) => {
          editor.setContent(`
            ${this.campaign.content}
          `);
          this.loadingEditor = false;
        },
      });
    },

    getEditorContent() {
      return window.tinymce && this.editor ? this.editor.getContent() : "";
    },
  },
};
</script>

<style scoped>
.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-2px);
}

.v-chip {
  margin: 2px;
}

.v-data-table >>> .v-data-table__wrapper {
  border-radius: 8px;
}

.v-tabs-items {
  background-color: transparent;
}

.v-card-title {
  border-radius: 16px 16px 0 0;
}

/* Editor Js Styling Starts Here */
.editor-container {
  /* max-width: 800px; */
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.editor-container:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  border-color: #cbd5e0;
}

.editor-header {
  background: linear-gradient(135deg, #667eee 0%, #764ba9 100%);
  padding: 16px 24px;
  color: white;
  display: flex;
  align-items: center;
  gap: 12px;
}

.editor-header-icon {
  width: 24px;
  height: 24px;
  opacity: 0.9;
}

.editor-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.editor-status {
  margin-left: auto;
  font-size: 12px;
  opacity: 0.8;
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot {
  width: 8px;
  height: 8px;
  background: #48bb78;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

#editorjs {
  min-height: 400px;
  padding: 24px;
  border: none;
  outline: none;
  font-size: 16px;
  line-height: 1.6;
  color: #2d3748;
  background: white;
  position: relative;
}

/* Editor.js specific styling */
#editorjs .ce-block__content {
  max-width: none;
}

#editorjs .ce-paragraph {
  line-height: 1.7;
  font-size: 16px;
}

#editorjs .ce-header {
  font-weight: 700;
  color: #1a202c;
}

/* Empty state styling */
#editorjs:empty::before {
  content: "Start writing your content here...";
  color: #a0aec0;
  font-style: italic;
  pointer-events: none;
  position: absolute;
  top: 24px;
  left: 24px;
}

/* Focus state */
.editor-container.focused {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1), 0 4px 20px rgba(0, 0, 0, 0.08);
}

/* Toolbar enhancement */
.ce-toolbar {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #e2e8f0 !important;
}

.ce-popover {
  border-radius: 8px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #e2e8f0 !important;
}

/* Footer info */
.editor-footer {
  padding: 12px 24px;
  background: #f7fafc;
  border-top: 1px solid #e2e8f0;
  font-size: 12px;
  color: #718096;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.word-count {
  font-weight: 500;
}

.last-saved {
  font-style: italic;
}

/* Responsive design */
@media (max-width: 768px) {
  .editor-container {
    margin: 0 10px;
    border-radius: 8px;
  }

  #editorjs {
    padding: 16px;
    min-height: 300px;
  }

  .editor-header {
    padding: 12px 16px;
  }

  .editor-header h3 {
    font-size: 16px;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  body {
    background-color: #1a202c;
  }

  .editor-container {
    background: #2d3748;
    border-color: #4a5568;
  }

  #editorjs {
    background: #2d3748;
    color: #e2e8f0;
  }

  #editorjs:empty::before {
    color: #718096;
  }

  .editor-footer {
    background: #1a202c;
    border-color: #4a5568;
    color: #a0aec0;
  }
}

/* Additional visual enhancements */
.editor-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
  z-index: 1;
}

/* Custom scrollbar */
#editorjs::-webkit-scrollbar {
  width: 6px;
}

#editorjs::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

#editorjs::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 3px;
}

#editorjs::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}
</style>
